// Configuration file for Badminton Shop UK

const config = {
  // Formspree Form IDs
  // Sign up at https://formspree.io and replace these with your actual form IDs
  formspree: {
    contactFormId: 'xqeekqon', // For Contact Us form
    notificationFormId: 'mqearbda' // For Email notification signup
  },

  // WhatsApp Configuration
  // Format: Country code + number (no spaces or special characters)
  // Example: For UK number 07123 456789, use: 447123456789
  whatsapp: {
    phoneNumber: '447XXXXXXXXX',
    defaultMessage: 'Hi, I\'m interested in your badminton products'
  },

  // Social Media Links
  social: {
    instagram: 'https://instagram.com/badmintonshopuk'
  }
};

export default config;
